import React from 'react';
import PropTypes from 'prop-types';
import IntroductionStep from './Steps/IntroductionStep';
import GeneralStep from './Steps/GeneralStep';
import ExclusiveStep from './Steps/ExclusiveStep';
import GenreStep from './Steps/GenreStep';
import FinalStep from './Steps/FinalStep';
import Error from './Errors/Error';
import { StepTypes } from './Steps/StepTypes';

export default class StepManager extends React.Component {
	static propTypes = {
		isAutoOpen: PropTypes.bool,
	};

	state = {
		step: 1,
		stepManagerDirection: 1,
	};

	render() {
		switch (this.state.step) {
			case StepTypes.IntroStep:
				return (
					<IntroductionStep
						nextStep={this.nextStep}
						isAutoOpen={this.props.isAutoOpen}
					/>
				);
			case StepTypes.GeneralStep:
				return (
					<GeneralStep
						nextStep={this.nextStep}
						previousStep={this.previousStep}
						stepManagerDirection={this.state.stepManagerDirection}
					/>
				);
			case StepTypes.ExclusiveStep:
				return (
					<ExclusiveStep
						nextStep={this.nextStep}
						previousStep={this.previousStep}
						stepManagerDirection={this.state.stepManagerDirection}
					/>
				);
			case StepTypes.GenreStep:
				return (
					<GenreStep
						nextStep={this.nextStep}
						previousStep={this.previousStep}
					/>
				);
			case StepTypes.FinalStep:
				return <FinalStep previousStep={this.previousStep} />;
			default:
				return <Error />;
		}
	}

	nextStep = event => {
		this.setState({ step: this.state.step + 1, stepManagerDirection: 1 });
	};

	previousStep = event => {
		this.setState({ step: this.state.step - 1, stepManagerDirection: -1 });
	};
}
